export default {"src":"/_next/static/media/discord.4c91a339.svg","height":45,"width":57};